import { render, staticRenderFns } from "./DevDesignIcons.vue?vue&type=template&id=2d9cd3ae&scoped=true"
import script from "./DevDesignIcons.vue?vue&type=script&lang=js"
export * from "./DevDesignIcons.vue?vue&type=script&lang=js"
import style0 from "./DevDesignIcons.vue?vue&type=style&index=0&id=2d9cd3ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9cd3ae",
  null
  
)

export default component.exports